<template>
<div>
    <div v-for="(task, index) in allItems" :key="index">
        <b-card class="modal-task">
            <div class="row set_goal_list" v-if="Object.keys(task.goal).length == 0">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="task-title">
                    
                    {{ task.description }}
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="webview">
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div class="task-title">
                            
                            {{ task.description }}
                            </div>
                        </div>
                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ calchoursonly(task.goal.task_hours) + '/' + task.goal.goal_hours + ' Task Hours' }}</div>
                        <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ task.goal.completion_date }} </div>
                    </div>
                </div>
                <div class="mobileview">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                            <div class="task-title">
                            
                            {{ task.description }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">
                            
                        </div>
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ calchoursonly(task.goal.task_hours) + '/' + task.goal.goal_hours + ' Task Hours' }}</div>
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.completion_date }} </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</div>
</template>
<script>
export default {
    props: ['allItems', 'itemLength', 'menteeId', 'tasklistId', 'subTaskId', 'headingId'],
    data() {
        return {
            modalTitle: '',
            completionDate: '',
            hours: '',
            repCount: '',
            taskHours: '',
            taskRepCount: '',
            goalId: '',
            submitValue: '',
            taskGoal: [],
        }
    },
    methods: {
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " hr. " + rminutes + " min ";
            }
            else {
                return rhours + " hr. ";
            }
        },
    }
}
</script>
<style scoped>
.dbAddRepsBtn, .dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 10px;
  width: 100%;
}
.task_goal_text {
  color:#00acee;
  text-align: left;
}
.task-title { padding: 0px; }
.set_goal_list { padding: 10px; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Medium Devices */
@media (min-width: 601px) and (max-width: 768px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .mobileview { display: none; }
  .webview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 5px; }
}
/* Extra Large Devices */
@media (min-width: 1200px) {
  .mobileview { display: none; }
  .webview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 5px; }
  
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentee_task_list.vue